import { mapEnumToOptions } from '@abp/ng.core';

export enum CategoryIncludePreset {
  Default = "Default",
  All = "All",
  Galleries = "Galleries",
  PremierGalleries = "Standard",
}

export const categoryIncludePresetOptions = mapEnumToOptions(CategoryIncludePreset);
